import { thunk } from 'easy-peasy';
import { IThunkUpdatedBloodPressureReading } from '../types';

const onUpdatedBloodPressureReading: IThunkUpdatedBloodPressureReading = thunk(
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async ({ setUpdatedBloodPressureReading }, payload, _) => {
    setUpdatedBloodPressureReading(payload);
  },
);

export default onUpdatedBloodPressureReading;
